import { h, render } from 'preact';
import parseJSON from '../utils/parseJSON';
import InternationalLandingPopup from './international-landing-popup';

export default (element) => {
  const INTERNATIONAL_POPUP_DISMISSED_KEY = 'internationalPopupDismissed';
  const body = document.querySelector('body');
  const modal = element;
  const fullData = parseJSON(modal.querySelector('#international-landing-popup-data').innerHTML);

  const closeButton = element.querySelector(
    '[data-target="close-international-landing-popup"]',
  );

  const contentContainer = modal.querySelector('.international-landing-popup-content');

  element.addEventListener('click', (event) => {
    if (event.target === element) {
      handleModalDismiss();
    }
  });

  closeButton.addEventListener('click', () => {
    handleModalDismiss();
  });

  window.addEventListener('resize', () => {
    element.close();
  });


  const handleModalDismiss = () => {
    body.classList.remove('overflow-hidden');
    element.close();
    setSessionStorage(INTERNATIONAL_POPUP_DISMISSED_KEY, true);
  };

  const handleModalOpen = () => {
    body.classList.add('overflow-hidden');
    modal.showModal();
  };

  const init = () => {
    const isIntLandingPopupDismissed = getSessionStorage(
      INTERNATIONAL_POPUP_DISMISSED_KEY,
    );

    if (!isIntLandingPopupDismissed) {
      window.addEventListener('load', checkDetectedCountry);
    }
  };

  const storageNotAvailable = (error) => {
    // eslint-disable-next-line no-console
    console.log('SessionStorage not available:', error);
  };

  const getSessionStorage = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      storageNotAvailable(error);
      return null;
    }
  };

  const setSessionStorage = (key, value) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      storageNotAvailable(error);
    }
  };

  const checkDetectedCountry = async () => {
    const response = await fetch(
      `${window.Shopify.routes.root}browsing_context_suggestions.json`
    );

    const data = await response.json();
    const detectedCountryCode = data?.detected_values?.country?.handle;
    if (detectedCountryCode && fullData[detectedCountryCode]) {
      renderCountryModal(fullData[detectedCountryCode]);
    }
  };

  const renderCountryModal = (data) => {
    if (!data || !contentContainer) {
      return;
    }
    render(<InternationalLandingPopup data={data} />, contentContainer);

    handleModalOpen();
  };

  init();
};
